import { GET_ACTIVE_LOCATION_OPTIONS_PENDING, GET_ACTIVE_LOCATION_OPTIONS_SUCCESS, GET_ACTIVE_LOCATION_OPTIONS_FAILURE } from './types';

const initialState = {
    loading: false,
    activeLocationOptions: [],
    error: ''
}

const activeLocationOptions = (state = initialState, action) => {
    switch (action.type) {
        case GET_ACTIVE_LOCATION_OPTIONS_PENDING:
            return {
                loading: true,
                activeLocationOptions: [],
                error: '',
            }
        case GET_ACTIVE_LOCATION_OPTIONS_SUCCESS:
            return {
                loading: false,
                activeLocationOptions: action.payload,
                error: ''
            }
        case GET_ACTIVE_LOCATION_OPTIONS_FAILURE:
            return {
                loading: false,
                activeLocationOptions: [],
                error: action.payload
            }
        default:
            return state
    }
}

export default activeLocationOptions;